import { Component } from '@angular/core';
import { SharedService } from '../../../../node_modules/baseline-lib';
import { Global } from '../../../global/global';
import { DatePipe } from '../../../../node_modules/@angular/common';
import {  NavController, LoadingController } from 'ionic-angular';
import { SundayRaffleDetailPage } from '../sunday-raffle-detail/sunday-raffle-detail';
import { CustomToast } from '../../shared/services/custom-toast';


/**
 * Generated class for the SundayRaffleComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'sunday-raffle',
  templateUrl: 'sunday-raffle.html'
})
export class SundayRaffleComponent {

  text: string;
  p: number = 1;
  rafflesList: any[] = [];
  _fromDate: any;
  _toDate: any;
  _serverError: any;
  isError: boolean;
  gameId: number;


  constructor(public _sharedServices: SharedService, public globalData:Global, public datepipe: DatePipe, public navCtrl: NavController, public loadingCtrl : LoadingController,
    public toast: CustomToast) {
    console.log('Hello SundayRaffleComponent Component');
    this.text = 'Hello World';
    this._fromDate = this._sharedServices.getServerTime().toISOString();
    this._toDate = this._sharedServices.getServerTime().toISOString();
  }

  ngOnInit() {
    this.isError = false;
    this.rafflesList = []; 
    this.getRafflesTicketsById(this.globalData.sundaybaffleid);    

  }

  getRafflesTicketsById(gametypeid: number) {
    this._sharedServices.getRecentWinnerResultByGameId(gametypeid)
      .subscribe(
        data => {          
          if(data != null) {
            if(data.pn) {
              this.rafflesList = [];
              this._serverError = '';
              this.isError = false
              this.rafflesList = data.pn;
            }
            else {
              this.isError = true;
              this.rafflesList = [];
              this._serverError = '';
              this._serverError = data.msg
              this.toast.showError(this._serverError);

              // setTimeout(() => { this._serverError = []; this.isError = false }, 4000);
            }            
          }
        },
        error => {
          if (error.error) {
            this.rafflesList = [];
            this._serverError = '';
            this._serverError = error.error;
            this.toast.showError(this._serverError);
            // setTimeout(() => { this._serverError = []; this.isError = false }, 4000);

          }
        });
  }

  validateDate(): boolean {
    this.rafflesList = [];
    this._serverError = '';
    let from_date = new Date(this._fromDate);
    let to_date = new Date(this._toDate);
    if (!this._fromDate || !this._toDate) {
      this._serverError = "Please select date.";
      this.isError = true;
      this.toast.showError(this._serverError);
      // setTimeout(() => { this._serverError = null; this.isError = false }, 4000);
      return false
    }
    if (from_date > to_date) {
      this._serverError = "To date should be greater than from date.";
      this.isError = true;
      this.toast.showError(this._serverError);
      // setTimeout(() => { this._serverError = null; this.isError = false }, 4000);
      return false
    }
    return true;
  }


  getRafflesTicketsByDate() {
    
    if (this.validateDate()) {
      const loader = this.loadingCtrl.create({
        content: "Please Wait",
      });
      loader.present();
      let resultReq: any = new Object();
      // resultReq.fd = this._sharedServices.getFormatedDate(this._fromDate);
      // resultReq.td = this._sharedServices.getFormatedDate(this._toDate);

      resultReq.fd = this.datepipe.transform(this._fromDate, 'yyyy-MM-dd');
      resultReq.td = this.datepipe.transform(this._toDate, 'yyyy-MM-dd');


      this._sharedServices.getRafflesTickets(this.globalData.sundaybaffleid,resultReq)
        .subscribe(
        data => {
          if (data != null) {
            this._sharedServices.hideLoader();
            if (data.pn) {
              this.rafflesList = [];
              this._serverError = '';
              this.isError = false;
              this.rafflesList = data.pn;
              loader.dismiss();
              this.navCtrl.push(SundayRaffleDetailPage,{"rafflesList" : this.rafflesList });

            }
            else {
              this.isError = true;
              this.rafflesList = [];
              this._serverError = '';
              this._serverError = data.msg
              loader.dismiss();
              this.toast.showError(this._serverError);

              // setTimeout(() => { this._serverError = []; this.isError = false }, 4000);
            }
          }
        },
        error => {
          if (error.error) {
            loader.dismiss();
            this.isError = true;
            this.rafflesList = [];
            this._serverError = '';
            this._serverError = error.error;
            this.toast.showError(this._serverError);

            // setTimeout(() => { this._serverError = []; this.isError = false }, 4000);

          }
        }
        );
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/lottery/sunday-raffle/sunday-raffle.ts